import { html, ref, slotted } from "@microsoft/fast-element";
import { Wizard } from "./wizard.js";
/**
 * The template for the {@link @fabric-msft/fabric-web#(Stepper:class)} component.
 * @public
 */
export function wizardTemplate() {
    return html `
    <template
      ?hidden="${(x) => x.hidden}"
      ?numbered="${(x) => x.numbered}"
      ?linear="${(x) => x.linear}"
      ?disable-on-complete="${(x) => x.disableOnComplete}"
      current-index="${(x) => x.currentIndex}"
      aria-hidden="${(x) => (x.hidden ? "true" : "false")}"
    >
      <div class="wizard" part="wizard">
        <slot name="start"></slot>
        <nav
          role="tablist"
          class="steps"
          part="steps"
          tabindex="0"
          @keydown="${(x, c) => x.handleStepContainerKeydown(c.event)}"
          ${ref("stepcontainer")}
        >
          <slot name="step" ${slotted("slottedsteps")}></slot>
        </nav>
        <div
          class="panels-container"
          part="panels-container"
          ${ref("panelcontainer")}
        >
          <div class="toolbar" part="toolbar">
            <div class="title" part="title"><slot name="title"></slot></div>
            <div class="button-container" part="button-container">
              <slot name="actions" ${slotted("slottedactions")}></slot>
            </div>
          </div>
          <div class="panels" part="panels">
            <slot name="panel" ${slotted("slottedpanels")}></slot>
          </div>
          <slot name="end"></slot>
        </div>
      </div>
    </template>
  `;
}
export const template = wizardTemplate();
//# sourceMappingURL=wizard.template.js.map